module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "washrooms-count"
  }, [_c('div', {
    staticClass: "washroom-icon",
    class: {
      'washroom-icon--large': _vm.large
    }
  }, [((_vm.washroom && _vm.washroom.facilityType == 'Male') || _vm.washroomType == 'Male') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--male.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'Female') || _vm.washroomType == 'Female') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--female.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'Disabled') || _vm.washroomType == 'Disabled') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--disabled.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'BabyChanging') || _vm.washroomType == 'BabyChanging') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--baby-changing.svg"
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e37c9df","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/WashroomIcon/WashroomIcon.vue
// module id = 553
// module chunks = 1